<template>
  <div class="md-layout p-0">
    <div
      class="md-layout-item md-size-25"
      v-for="(card, index) in dataSynthetic"
      :key="card.title + index"
    >
      <card-report :icon="card.icon" :title="$t(card.title)">
        <template #report-admin>
          <div class="flex justify-between font-medium text-lg mt-4">
            <span>{{ card.quantity || 0 }}</span>
            <span class="text-success text-sm">{{ $t(card.status) }}</span>
          </div>
        </template>
      </card-report>
    </div>
  </div>
</template>
<script>
import CardReport from "../../Components/CardReport";
export default {
  name: "synthetic",
  components: { CardReport },
  props: ["data"],
  computed: {
    dataSynthetic() {
      return [
        {
          icon: "fas fa-user-graduate",
          title: "dashboard.synthetic.total_teachers",
          quantity: this.data.total_teacher,
          status: "common.active"
        },
        {
          icon: "fas fa-users",
          title: "dashboard.synthetic.total_students",
          quantity: this.data.total_student,
          status: "common.active"
        },
        {
          icon: "fas fa-user-tie",
          title: "dashboard.synthetic.total_counselors",
          quantity: this.data.total_counselor,
          status: "common.active"
        },
        {
          icon: "fas fa-warehouse",
          title: "dashboard.synthetic.total_classes",
          quantity: this.data.total_class,
          status: "common.on_going"
        }
      ];
    }
  }
};
</script>
